import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'subForm', 'additionalInputs', 'amortization']

  static values = {
    clearEntitiesStandardForm: Boolean
  }

  get selectedValue() {
    return this.radioTargets.find(input => input.checked)?.value?.toLowerCase()
  }

  get selectedSubForm() {
    return this.subFormTargets.find(target => target.dataset.value === this.selectedValue)
  }

  get entitiesStandardForm() {
    return this.subFormTargets.find(target => target.dataset.value === 'standard')
  }

  connect() {
    this.element.controller = this
    this.refresh()
    if (this.clearEntitiesStandardFormValue === true) {
      this.clearEntitiesStandardForm()
    }
  }

  refresh(event) {
    if (this.selectedValue) {
      this.hideSections()
      this.showSection(this.selectedSubForm)
      this.showAdditionalInputs()
      if (this.newActivityDatumForm(event)) {
        this.emptyAmortizationInput()
      }
    }
  }

  clearEntitiesStandardForm() {
    if (this.selectedSubForm != this.entitiesStandardForm) {
      this.entitiesStandardForm.querySelectorAll('select').forEach(select => (select.value = ''))
    }
  }

  newActivityDatumForm(event) {
    return event?.currentTarget.closest('form').classList.contains('new_activity_datum')
  }

  showAdditionalInputs() {
    if (this.hasAdditionalInputsTarget) {
      this.showSection(this.additionalInputsTarget)
    }
  }

  emptyAmortizationInput() {
    if (this.hasAmortizationTarget) {
      this.amortizationTarget.value = ''
    }
  }

  showSection(section) {
    if (!section) return
    section.classList.remove('d-none')
  }

  hideSections() {
    this.subFormTargets.forEach(el => el.classList.add('d-none'))
  }
}
